/** List row states for admin list + form (super user / admin) layouts */
export function adminListRowHighlightClass(selected: boolean): string {
  return selected
    ? "border border-brand-maroon/50 bg-brand-maroon/8 shadow-sm"
    : "border border-transparent hover:bg-brand-gray/25";
}
